import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Tours from '../components/Tours';
import TourPreview from './tours/Preview';
import Header from './layout/Header';
import Map from './Map';
import * as toursActions from '../actions/tours';
import { Link } from 'react-router';
import * as TourActions from '../actions/tour';
import Translate from './layout/Translate';
import Facebook from './popups/Facebook';
import Helmet from "react-helmet";



class Destinations extends Component {





    selectDestination(destination) {
        this.props.toursActions.selectDestination(destination)
    }


    render () {
        let {destinations, seo, translations} = this.props;

        return (

            <section className="section " ref="main">


                <div className="section__content">
                    <Header />
                    <div className="tours promo">

                        {seo.h1 &&
                            <h1>{seo.h1}</h1>
                        }
                        {!seo.h1 &&
                            <h1><Translate slug="header__tours" /></h1>
                        }

                        {translations['destinations__text'] &&
                            <div className="container__description container__description_center">
                                <Translate slug="destinations__text" />
                            </div>
                        }


                        <div className="container destinations">
                            {destinations.map((destination, i)=>
                                <Link to={"/destinations/" + destination.slug} onClick={this.selectDestination.bind(this, destination)} className="destination" style={{backgroundImage: ((destination.coverImages && destination.coverImages.previews.original)?"url("+destination.coverImages.previews.original+")":"none")}}>
                                    {destination.title}
                                </Link>
                            )}

                            <div className="clearfix"></div>

                        </div>

                        {seo.text &&
                            <div className="container__description">
                                <div dangerouslySetInnerHTML={{__html:seo.text}}></div>
                            </div>
                        }


                    </div>
                    <Facebook />
                    
                    <div className="footer__registration">
                        <Translate
                            slug="main__registration"/>
                    </div>
                </div>


            </section>
        );
    }
}


Destinations.need = [

];



function mapStateToProps(state) {



    return {
        destinations: state.tours.destinations,
        seo: state.user.seo,
        translations: state.user.translations
    };
}


function mapDispatchToProps(dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Destinations)





// WEBPACK FOOTER //
// ./src/common/components/Destinations.js